var _defs, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnnualBilling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8762",
    "data-name": "Group 8762",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4768",
    "data-name": "Rectangle 4768",
    width: 22,
    height: 21,
    transform: "translate(-0.052 -0.01)",
    fill: "#d13c3c"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_728",
    "data-name": "Ellipse 728",
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#fff0f0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10039",
    "data-name": "Group 10039",
    transform: "translate(14.052 14.51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10039-2",
    "data-name": "Group 10039",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5658",
    "data-name": "Path 5658",
    d: "M0,8.507V8.036A1.259,1.259,0,0,1,1.165,7.11l6.216-.558L9.9.662A1.135,1.135,0,0,1,10.929,0a1.12,1.12,0,0,1,1.055.635l2.533,5.914,6.355.583a1.135,1.135,0,0,1,.953.759,1.122,1.122,0,0,1-.276,1.219L16.721,13.35l1.416,6.259a1.136,1.136,0,0,1-.474,1.155,1.152,1.152,0,0,1-1.276.043l-5.438-3.253-5.44,3.253a1.165,1.165,0,0,1-1.746-1.233l1.413-6.226L.546,9.3A1.5,1.5,0,0,1,0,8.507",
    transform: "translate(0 0)",
    fill: "#d13c3c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnualBilling);
export default __webpack_public_path__ + "static/media/annual_billing.18071f981c80515e5dc95c2bd8a13981.svg";
export { ForwardRef as ReactComponent };